var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body flex justify-content-between" }, [
        _c("div", { staticClass: "flex" }, [
          _c(
            "div",
            [
              _c("input", {
                ref: "uploadFileInput",
                staticClass: "input-file pointer",
                attrs: { type: "file", accept: ".csv" },
                on: { change: _vm.chooseFile },
              }),
              _vm._v(" "),
              _c("LoadingButton", {
                attrs: {
                  title: "Загрузить заявки через файл",
                  type: "button",
                  loading: _vm.loading,
                  color: _vm.$constants.PRIMARY_COLOR,
                  onClick: () => _vm.uploadFile(),
                  className: "btn btn-outline-success btn-xs",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ml-1" },
            [
              _c("input", {
                ref: "uploadCheckFileInput",
                staticClass: "input-file pointer",
                attrs: { type: "file", accept: ".pdf" },
                on: { change: _vm.chooseCheckFile },
              }),
              _vm._v(" "),
              _c("LoadingButton", {
                attrs: {
                  title: "Проверка индексов",
                  type: "button",
                  loading: _vm.loading,
                  color: _vm.$constants.PRIMARY_COLOR,
                  onClick: () => _vm.checkIndex(),
                  className: "btn btn-outline-info btn-xs",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            [..._vm.errorOrders, ..._vm.solvedOrders].length
              ? _c("LoadingButton", {
                  attrs: {
                    title: "Закрыть заявки",
                    type: "button",
                    loading: _vm.loading,
                    color: _vm.$constants.SUCCESS_COLOR,
                    onClick: () => _vm.confirmOrders(),
                    className: "btn btn-outline-success btn-xs",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.checkOrders && !_vm.selectedFile
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("CheckedPostOrdersList", {
                attrs: {
                  pass: _vm.checkOrders.pass,
                  errors: _vm.checkOrders.errors,
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.solvedOrders.length || _vm.errorOrders.length
      ? _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("table", { staticClass: "table mt-0 table-hover table-sm" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("#")]),
                  _vm._v(" "),
                  _c("th", [
                    _c("input", {
                      attrs: { type: "checkbox" },
                      on: { change: _vm.selectAll },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("th", [_vm._v("ID")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Клиент")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Адрес")]),
                  _vm._v(" "),
                  _c("th"),
                  _vm._v(" "),
                  _c("th"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(
                  [..._vm.errorOrders, ..._vm.solvedOrders],
                  function (o, i) {
                    return _c(
                      "tr",
                      [
                        _c("td", [_vm._v(_vm._s(i + 1))]),
                        _vm._v(" "),
                        _c("td", [
                          o.id
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedOrders[o.id],
                                    expression: "selectedOrders[o.id]",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.selectedOrders[o.id]
                                  )
                                    ? _vm._i(_vm.selectedOrders[o.id], null) >
                                      -1
                                    : _vm.selectedOrders[o.id],
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.selectedOrders[o.id],
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.selectedOrders,
                                            o.id,
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.selectedOrders,
                                            o.id,
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.selectedOrders, o.id, $$c)
                                    }
                                  },
                                },
                              })
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        o.order
                          ? [
                              _c("td", [_vm._v(_vm._s(o.order.id))]),
                              _vm._v(" "),
                              _c("td", [
                                _c("p", [_vm._v(_vm._s(o.order.client_name))]),
                                _vm._v(" "),
                                _c("p", [_vm._v(_vm._s(o.order.phone))]),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("p", [_vm._v(_vm._s(o.order.address))]),
                                _vm._v(" "),
                                _c("p", [_vm._v(_vm._s(o.order.track_number))]),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("p", [_vm._v(_vm._s(o.message))]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v("стоимость: "),
                                  _c("strong", [
                                    _vm._v(_vm._s(o.order.post_sum)),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td"),
                            ]
                          : [
                              _c("td", [_vm._v(_vm._s(o.id))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(o.client_name))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(o.address))]),
                              _vm._v(" "),
                              _vm._m(0, true),
                              _vm._v(" "),
                              _c("td"),
                            ],
                      ],
                      2
                    )
                  }
                ),
                0
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("span", { staticClass: "badge badge-success" }, [
        _vm._v("Верифицирована"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }